import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  answerPacks: [],
  error: true,
  loading: false,
  questions: [],
  survey: {},
  surveyKey: undefined,
  currentQuestion: 0,
  totalVotesCount: 0,
  averageVotesCount: 0,
  userVotes: [],
  duration: 0
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
